import React from 'react';
import Dialog from "../../../components/Dialog";
import { IconButton, Stack } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import TextField from "../../../components/form/TextField";
import { Edit } from "@mui/icons-material";
import SingleFieldForm from "../offer-creator/common/SingleFieldForm";

const EditableLabel: React.FC<EditableLabelProps> = props => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [value, setValue] = React.useState(props.initialValue);
    const [editedValue, setEditedValue] = React.useState(props.initialValue);
    return (
        <>
            <Stack direction='row' spacing={ 1 } alignItems='center'>
                <span>{ props.label }</span>
                <span style={ { whiteSpace: 'nowrap' } }>{ value }</span>
                <IconButton size='small' onClick={ () => setIsDialogOpen(true) }>
                    <Edit fontSize='small'/>
                </IconButton>
            </Stack>
            <Dialog open={ isDialogOpen } onCloseClick={ () => setIsDialogOpen(false) }>
                <DialogContent sx={ { minWidth: '600px' } }>
                    <Stack pt={ 2 }>
                        <SingleFieldForm
                            initialValue={ editedValue }
                            fieldName='value'
                            onSubmit={ values => {
                                props.onSave(values.value);
                                setIsDialogOpen(false);
                                setValue(values.value);
                                setEditedValue(values.value);
                            } }
                        >
                            <TextField
                                size='small'
                                name='value'
                                label={ props.label }
                                autoFocus
                            />
                        </SingleFieldForm>
                    </Stack>
                </DialogContent>
            </Dialog>
        </>
    );
}
export default EditableLabel;

export interface EditableLabelProps {
    readonly label: string;
    readonly initialValue: string;
    readonly onSave: (value: string) => any;
}